import styled from "styled-components";
import Text from "../Text";
import ButtonRulesBlock from "../ButtonRulesBlock";
import ButtonRuleSlide from "../ButtonRuleSlide";
import rulesData from "./rulesData"; // relative path
import { useState } from "react";
import CloseX from "../CloseX";
import BackgroundGrid from "../../assets/bg-grid.svg";

const Container = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: end;
  position: fixed;
  /* bottom: 0; */
  left: 0;
  background-color: var(--bg-light-blue);
  background-image: url(${BackgroundGrid});
  background-position: center;
  background-size: 100vw;
  z-index: 100;
`;

const Modal = styled.div`
  width: 90%;
  height: 85%;
  border-radius: 10px;
  display: grid;
  background-color: var(--bg-dark-blue);
  grid-template-columns: 2fr 5fr;
  grid-template-rows: 6fr 4fr;
  grid-template-areas:
    "sidebar imageSpace"
    "sidebar paragraphSpace";
`;

const Sidebar = styled.div`
  margin-right: 5px;
  border-radius: 10px 0 0 0;
  grid-area: sidebar;
  background-color: var(--bg-dark-blue);
  display: flex;
  flex-direction: column;
  text-align: start;
  justify-content: start;
  align-items: center;
  position: relative;
`;

const SidebarUpperContainer = styled.div`
  /* max-width: 50%; */
  /* height: 50%; */
  border-right: 2px solid var(--highlight);
  border-bottom: 2px solid var(--highlight);

  padding: 50px 0;
  width: 100%;

  & > * {
    padding-left: 70px;
  }
`;

const SidebarLowerContainer = styled.div`
  /* max-width: 50%; */
  /* height: 50%; */
  display: flex;
  flex-direction: column;
  gap: 50px;
  padding-top: 50px;
  margin-top: 5px;
  width: 100%;
  border-right: 2px solid var(--highlight);
  border-top: 2px solid var(--highlight);
  height: 100%;

  & > * {
    padding-left: 80px !important;
  }
`;

const ImageContainer = styled.div`
  grid-area: imageSpace;
  background-color: var(--bg-dark-blue);
  display: flex;
  justify-content: center;
  border-radius: 0 10px 0 0;
  overflow: hidden;
  border: 2px solid var(--highlight);
`;

const Image = styled.img`
  height: 100%;
`;

const Paragraph = styled.div`
  grid-area: paragraphSpace;
  display: flex;
  justify-content: center;
  align-items: center;

  background-color: var(--bg-dark-blue);
  border-left: 2px solid var(--highlight);
`;
const ParagraphContainer = styled.div`
  grid-area: paragraphSpace;
  width: 80%;
  height: 100%;
  max-height: 100%;

  display: grid;
  grid-template-rows: 1fr 0.2fr;
  grid-column: 1fr;
  justify-content: center;
  align-items: center;
`;

const ButtonSelectSlideContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  align-self: center;
`;

const data = rulesData;

const ruleBlocks = [
  { key: "goal", label: "Στόχος" },
  { key: "points", label: "Πόντοι" },
  { key: "lives", label: "Ζωές" },
  { key: "audios", label: "Ηχητικά" },
];



const GameRulesModal = ({ handleClose, open }) => {
  // let [slide, setSlide] = useState(0);
  let [block, setBlock] = useState("goal");
  let [bullet, setBullet] = useState(0);

  const handleBulletChange = (bulletIndex) => {
    setBullet(bulletIndex);
  };
  const handleBlockChange = (blockValue) => {
    setBlock(blockValue);
    setBullet(0);
  };

  // const handleSlideChange = (slideValue) => {
  //   setSlide(slideValue);
  // }

  if (!open) return null;
  return (
    <Container>
      <CloseX handleClick={handleClose} open={open} />
      <Modal>
        <Sidebar>
          <SidebarUpperContainer>
            {/* <div style={{
              borderTop: "1px solid var(--highlight)",
              borderBottom: "1px solid var(--highlight)",
              width: "98%",
              height: "5px",
              position: "absolute",
              left: "0",
              top: "20%"
              }}>

            </div> */}
            <Text fontSize="45px" fontFamily="'Source Serif 4'" fontWeight="bold" padding-left="70px">
              Κανόνες
            </Text>
          </SidebarUpperContainer>
          <SidebarLowerContainer>
            {ruleBlocks.map(({ key, label }) => (
  <ButtonRulesBlock
    key={key}
    text={label}
    selected={block === key ? 1 : 0}
    value={key}
    onButtonClick={handleBlockChange}
  />
))}

          </SidebarLowerContainer>
        </Sidebar>
        <ImageContainer>
          <Image src={data[block][bullet].image} />
        </ImageContainer>
        <Paragraph>
          <ParagraphContainer>
            {/* {data[block].map(el => {
                return( 
                <Text 
                fontSize="20px"
                fontFamily="Manrope"
                color="black"
                >
                  {el.text}
                </Text>);
            })} */}
            <Text
              fontSize="20px"
              fontFamily="Manrope"
              color={`var(--text-light)`}
            >
              {data[block][bullet].text}
            </Text>

            <ButtonSelectSlideContainer>
              {data[block].map((el, index) => {
                return (
                  <ButtonRuleSlide
                    selected={
                      index === bullet
                        ? `var(--button)`
                        : `var(--button-inactive)`
                    }
                    onBulletClick={handleBulletChange}
                    index={index}
                    currentBullet={bullet}
                    key={index}
                  />
                );
              })}
            </ButtonSelectSlideContainer>
          </ParagraphContainer>
        </Paragraph>
      </Modal>
    </Container>
  );
};

export default GameRulesModal;
